import React from 'react';
import { SERVICES } from '../data/mockData';
import { Building2, Banknote, Palette, Scale, ArrowRight } from 'lucide-react';

const iconMap = {
  building2: Building2,
  banknote: Banknote,
  palette: Palette,
  scale: Scale,
};

const Services = () => {
  return (
    <section className="py-24 bg-[#f8f7f4]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-2 text-xs font-semibold tracking-[0.2em] text-[#DAA520] border border-[#DAA520]/30 rounded-sm mb-4">
            OUR SERVICES
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-3">
            What We Offer
          </h2>
          <div className="w-12 h-0.5 bg-[#DAA520] mx-auto mb-4" />
          <p className="text-gray-600 max-w-xl mx-auto">
            Comprehensive real estate services designed to make your property journey seamless
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {SERVICES.map((service) => {
            const Icon = iconMap[service.icon];
            return (
              <div
                key={service.id}
                className="group bg-white rounded-lg p-8 shadow-md hover:shadow-xl transition-all duration-500 border border-gray-100 hover:border-[#DAA520]/20 hover:-translate-y-1"
              >
                <div className="w-14 h-14 rounded-full bg-[#DAA520]/10 flex items-center justify-center mb-6 group-hover:bg-[#DAA520]/20 transition-colors duration-300">
                  <Icon size={26} className="text-[#DAA520]" />
                </div>
                <h3 className="text-gray-900 font-semibold text-lg mb-3 group-hover:text-[#DAA520] transition-colors">
                  {service.title}
                </h3>
                <p className="text-gray-500 text-sm leading-relaxed mb-5">
                  {service.description}
                </p>
                <button className="flex items-center gap-2 text-[#DAA520] text-sm font-semibold tracking-wider hover:gap-3 transition-all duration-300">
                  LEARN MORE
                  <ArrowRight size={14} />
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
